<div class="tiles-container">
    <app-page-header>
      <div class="audit-trail-common-header">
        <h2 class="title inline-block font-size-32">Audit Trail</h2>
        <span class="clear-filters" (click)="clearAllFilter()">Clear filters</span>
      </div>
    </app-page-header>
    <div class="row padding-top-l">
        <div *ngIf="clientNameValue !== null">
          <span class="eclipse-content-grey padding-right-xxs">Client name:</span>
          <span class="padding-right-vs">{{ clientNameValue }}</span>
        </div>
      <div class="row padding-top-s">
        <app-common-audit-trail
          [moduleId]="moduleId"
          [moduleName]="moduleName"
          (headerData)="headerData($event)"
        />
      </div>
    </div>
  </div>
  